import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import DocumentList from '@/components/documents/DocumentList';
import { useDocuments } from '@/components/documents/useDocuments';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

const Documents = () => {
  const { data: documents, isLoading, error } = useDocuments();

  return (
    <div className="min-h-screen bg-cream font-sans">
      {/* Header Section */}
      <div className="container mx-auto px-4 py-12 md:py-16">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h1 className="text-2xl md:text-3xl font-semibold text-navy mb-4">
            Documentos para tu Trámite
          </h1>
          <p className="text-base md:text-lg text-coolGray leading-relaxed max-w-2xl mx-auto">
            Accede a los formularios oficiales que podrías necesitar para tu proceso migratorio.
          </p>
        </div>

        {/* Document List Container */}
        <div className="max-w-4xl mx-auto">
          <Card className="bg-white shadow-lg border border-gray-100/50">
            <CardContent className="p-0">
              {isLoading ? (
                <div className="p-6">
                  <div className="space-y-6">
                    {[1, 2, 3].map((i) => (
                      <div key={i} className="flex items-center gap-4 p-4 border border-gray-100 rounded-lg">
                        <Skeleton className="h-12 w-12 rounded-lg" />
                        <div className="flex-1 space-y-2">
                          <Skeleton className="h-5 w-3/4" />
                          <Skeleton className="h-4 w-1/2" />
                        </div>
                        <Skeleton className="h-10 w-24" />
                      </div>
                    ))}
                  </div>
                </div>
              ) : error ? (
                <div className="p-6">
                  <Alert variant="destructive">
                    <AlertCircle className="h-4 w-4" />
                    <AlertTitle>Error al cargar documentos</AlertTitle>
                    <AlertDescription>
                      Lo sentimos, ha ocurrido un error al cargar los documentos. Por favor, inténtelo de nuevo más tarde o contacte al administrador.
                    </AlertDescription>
                  </Alert>
                </div>
              ) : (
                <DocumentList documents={documents || []} />
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Documents;
